'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.theme = undefined;

var _theme = require('web-makeup/dist/design-system/config/data/theme');

var theme = exports.theme = {
    lineHeight: '1.1rem',
    colors: {
        black: '#484848',
        darkGrey: '#333',
        grey: '#9B9B9B',
        lighterGrey: '#bababa',
        lightGrey: _theme.colors.dust,
        white: 'white',
        lightblue: '#eef6fc',
        lightred: '#fff1f0',
        purple: '#6057ff',
        blue: '#31afd8',
        dodgerBlue: '#33abfb',
        green: '#42a101',
        transparent: 'transparent'
    },
    delimiter: {
        color: '#bababa',
        space: '0.4rem'
    }
};
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/config/data/theme.js
// module id = 1932
// module chunks = 0